/// <amd-module name="Test/TestPlansLibrary/TestCasesPivotFilter/TestCasesPivotFilterConstants" />
export const TestCasesTextFilterItemKey = "testCasesFilterText";
export const TestCasesAssignedToFilterItemKey = "testCasesAssignedToFilter";
export const TestCasesStateFilterItemKey = "testCasesStateFilter";
export const TestCasesAreaFilterItemKey = "testCasesAreaFilter";
export const TestCasesTagsFilterItemKey = "testCasesTagsFilter";
export const TestCasesPriorityFilterItemKey = "testCasesPriorityFilter";
export const TestCasesQueriesFilterItemKey = "testCasesQueriesFilter";
